import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import firebase from "firebase/app";
import async from "async";
import CategoriesList from "../../components/categories/CategoriesList";
import { useTheme } from "@mui/material/styles";
import ProductCard from "../../components/products/ProductCard";
import FullScreenLoading from "../../components/FullScreenLoading";

const HomeScreen = ({}) => {
  const [recommendedProducts, setRecommendedProducts] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  React.useEffect(() => {
    loadData();
    return () => {
      setRecommendedProducts([]);
      setCategories([]);
    };
  }, []);

  const loadData = () => {
    setLoading(true);
    async.series(
      [
        function (callback) {
          getRecommended(callback);
        },
        function (callback) {
          getCategories(callback);
        },
      ],
      async (err, results) => {
        if (err) {
          console.error("error is ", err);
        }
        const recommendedData = results[0];
        setRecommendedProducts(recommendedData);

        const _categories = results[1];
        setCategories(_categories);

        setLoading(false);
      }
    );
  };

  const getRecommended = (callback) => {
    firebase
      .firestore()
      .collection("products")
      .limit(5)
      .get()
      .then((result) => {
        const data = result.docs.map((d) => ({
          ...d.data(),
          createdAt:
            d.data().createdAt && d.data().createdAt.toDate
              ? d.data().createdAt.toDate()
              : d.data().createdAt,
          currentDiscountExpiry:
            d.data().currentDiscountExpiry &&
            d.data().currentDiscountExpiry.toDate
              ? d.data().currentDiscountExpiry.toDate()
              : d.data().currentDiscountExpiry,
        }));
        callback(null, data);
      })
      .catch((err) => {
        callback(null, []);
      });
  };

  const getCategories = (callback) => {
    firebase
      .firestore()
      .collection("categories")
      .get()
      .then((result) => {
        const data = result.docs.map((d) => ({
          ...d.data(),
          createdAt:
            d.data().createdAt && d.data().createdAt.toDate
              ? d.data().createdAt.toDate()
              : d.data().createdAt,
        }));
        callback(null, data);
      })
      .catch((err) => {
        callback(null, []);
      });
  };

  if (loading) {
    return <FullScreenLoading />;
  }

  return (
    <>
      {/* <main> */}
      <div style={{ width: "100%", padding: "-10px" }}>
        <CategoriesList categories={categories} />
      </div>
      {recommendedProducts && recommendedProducts.length > 0 && (
        <Container sx={{ py: 8 }} maxWidth="lg">
          <Grid container spacing={4} sm={12} xs={12}>
            {recommendedProducts.map((item, index) => (
              <ProductCard card={item} key={index + "Card Product Home"} />
            ))}
          </Grid>
        </Container>
      )}
      {/* </main> */}
    </>
  );
};

export default HomeScreen;
